"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
//@ts-ignore
const vue_click_outside_1 = __importDefault(require("vue-click-outside"));
// Vue components
const Sidebar_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/Sidebar.vue"));
const Configuration_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/Configuration.vue"));
const Metadata_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/Metadata.vue"));
const SelectionArea_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/SelectionArea.vue"));
const Library_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/Library.vue"));
const Render_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/render/Render.vue"));
const BasicUI_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/render/components/BasicUI.vue"));
const Viz_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/render/components/Viz.vue"));
const Map_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/render/components/Map.vue"));
const PropertiesBar_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/PropertiesBar.vue"));
const General_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/components/General.vue"));
const GroupArea_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/components/GroupArea.vue"));
const HiddenArea_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/components/HiddenArea.vue"));
const OrderArea_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/components/OrderArea.vue"));
const TargetProps_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/components/TargetProps.vue"));
// Blocking Loader
const UIBlockingLoader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIBlockingLoader.vue"));
// Models
const Heatmap_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Heatmap"));
// Utils
const lucide_vue_next_1 = require("lucide-vue-next");
const Options_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/options/Options"));
let Heatmap2View = class Heatmap2View extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // The heatmap
        this.heatmap = null;
        this.mapActive = false;
        this.fsActive = false;
        this.fsActiveMap = false;
        // Sidebar
        this.configurationExpanded = false;
        this.configurationUpdatable = false;
        //metadataLoaded: boolean = false;
        this.libraryExpanded = false;
        // Propbar
        this.generalExpanded = false;
        this.groupExpanded = false;
        this.orderExpanded = false;
        this.hiddenExpanded = false;
        this.targetExpanded = false;
        // Current Config
        this.currentConfig = {
            name: 'myconfig',
            modified: true,
        };
        // Blocking Loader Config
        this.blockingLoaderConfig = {
            title: 'Refreshing Heatmap',
            subtitle: 'Wait a few seconds...',
            dim: 60,
        };
    }
    expandConfiguration(currentStatus) {
        if (currentStatus == false)
            this.collapseEverythingSidebar();
        this.configurationExpanded = !this.configurationExpanded;
    }
    expandLibrary(currentStatus) {
        if (currentStatus == false)
            this.collapseEverythingSidebar();
        this.libraryExpanded = !this.libraryExpanded;
    }
    collapseEverythingSidebar() {
        this.configurationExpanded = false;
        this.libraryExpanded = false;
    }
    //Collapsing Propbar
    expandGeneral(newStatus) {
        if (newStatus == true)
            this.collapseEverythingPropbar();
        this.generalExpanded = newStatus;
    }
    expandOrder(newStatus) {
        if (newStatus == true)
            this.collapseEverythingPropbar();
        this.orderExpanded = newStatus;
    }
    expandGroup(newStatus) {
        if (newStatus == true)
            this.collapseEverythingPropbar();
        this.groupExpanded = newStatus;
    }
    expandHidden(newStatus) {
        if (newStatus == true)
            this.collapseEverythingPropbar();
        this.hiddenExpanded = newStatus;
    }
    expandTarget(newStatus) {
        if (newStatus == true)
            this.collapseEverythingPropbar();
        this.targetExpanded = newStatus;
    }
    collapseEverythingPropbar() {
        this.generalExpanded = false;
        this.orderExpanded = false;
        this.groupExpanded = false;
        this.hiddenExpanded = false;
        this.targetExpanded = false;
    }
    onHeatmapRefreshed() {
        if (this.heatmap)
            this.heatmap.need_refresh = false;
    }
    triggerHeatmapRefresh() {
        if (this.heatmap)
            this.heatmap.need_refresh = false;
    }
    onItemActive() {
        // Search element of the id and focus level and fill the Element Object
        // console.log('This should be set active from here');
    }
    toggleMap() {
        this.mapActive = !this.mapActive;
    }
    toggleFullScreen() {
        this.fsActive = !this.fsActive;
    }
    // toggleFullScreenMap() {
    //     this.fsActiveMap = !this.fsActiveMap
    // }
    closeMap() {
        this.mapActive = false;
    }
    mounted() {
        this.heatmap = new Heatmap_1.default();
        this.initHeatmap();
    }
    async initHeatmap() {
        await Options_1.default.load();
        await this.heatmap.loadSamples();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Heatmap2View.prototype, "is_biome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Heatmap2View.prototype, "map_config", void 0);
Heatmap2View = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Sidebar: Sidebar_vue_1.default,
            Configuration: Configuration_vue_1.default,
            Metadata: Metadata_vue_1.default,
            SelectionArea: SelectionArea_vue_1.default,
            Library: Library_vue_1.default,
            Render: Render_vue_1.default,
            BasicUI: BasicUI_vue_1.default,
            Viz: Viz_vue_1.default,
            Map: Map_vue_1.default,
            PropertiesBar: PropertiesBar_vue_1.default,
            General: General_vue_1.default,
            GroupArea: GroupArea_vue_1.default,
            HiddenArea: HiddenArea_vue_1.default,
            OrderArea: OrderArea_vue_1.default,
            TargetProps: TargetProps_vue_1.default,
            UIBlockingLoader: UIBlockingLoader_vue_1.default,
            ChevronLeft: lucide_vue_next_1.ChevronLeft,
        },
        directives: {
            ClickOutside: vue_click_outside_1.default,
        },
    })
], Heatmap2View);
exports.default = Heatmap2View;
